<template>
  <div class="w-full">
    <lcontainer class="mb-4">
      <div class="heading flex flex-row items-center justify-between py-2 px-8">
        <div>
          <div class="page text-white">Learning Journal</div>
        </div>
        <div>
          <img :src="require('../../../assets/tenant_image.png')" alt="" />
        </div>
      </div>
    </lcontainer>
    <div class="">
      <lCrumbs class="mx-4 py-4" :breadcrumb="breadcrumbItems" />
      <div class="block sm:flex sm:justify-even sm:flex-wrap">
        <note
          v-if="notes"
          
          @save="sendNote"
          v-model="notes"
        />
        <!-- @download="downloadPdf" -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

//const doc = new jsPDF();
export default {
  components: {
    lcontainer: () => import("@/components/general/container"),
    card: () => import("@/components/learner/notesCard"),
    Note: () => import("@/components/general/note"),
    lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
  },
  data() {
    return {
      search: "",
      boards: [],
      notes: "",
      data: null,
      breadcrumbItems: [
        {
          disabled: true,
          to: "/learner/notes/",
          text: "All Journals >",
        },
      ],
    };
  },
  methods: {
    ...mapActions(["LearnerFetchJournal", "createNote"]),
    async sendNote() {
      let res = await this.createNote({
        id: this.data.lesson_id,
        note: this.notes,
      });
      if (res.status == 201 || res.status == 200) {
        this.$Bus.$emit("notify", {
          type: "success",
          message: "Journal  saved successfully",
        });
      } else {
        this.loading = false;
        this.$Bus.$emit("notify", {
          type: "error",
          message: res.data.errors
            ? res.data.errors[0].title
            : "An error occured",
        });
      }
    },
    downloadPdf() {
      let text = this.extractContent(this.notes, true);
      //doc.text(text, 10, 10);
      //doc.save("LessonNote.pdf");
    },
    extractContent: (s, space) => {
      let span = document.createElement("span");
      span.innerHTML = s;
      if (space) {
        let children = span.querySelectorAll("*");
        for (let i = 0; i < children.length; i++) {
          if (children[i].textContent) children[i].textContent += " ";
          else children[i].innerText += " ";
        }
      }
      return [span.textContent || span.innerText]
        .toString()
        .replace(/ +/g, " ");
    },
  },
  computed: {},
  async created() {
    let res = await this.LearnerFetchJournal({ id: this.$route.params.id });
    this.notes = res.data.data.journal.note;
    this.data = res.data.data.journal;
    console.log({ res: this.data });
  },
};
</script>
<style scoped></style>
